<template>
  <div>
    <h4 class="title-bar">작업 시간 설정</h4>
    <el-radio-group v-model="scheduleType">
      <el-radio v-for="item in keys(scheduleTypeObj)" :key="item" :label="item">{{ scheduleTypeObj[item].label }}</el-radio>
    </el-radio-group>
    <hr class="mr-t10">
    <div v-show="scheduleType === 'O'">
      <!-- add margins 1217 -->
      <div class="mr-t10 mr-b3">시작시간</div>
      <el-row>
        <el-select v-model="oSchedule.startTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="oSchedule.startMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr class="mr-t10">
      <div class="mr-t10 mr-b3">종료시간</div>
      <el-row>
        <el-select v-model="oSchedule.endTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="oSchedule.endMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
    </div>
    <div v-show="scheduleType === 'D'">
      <div class="mr-t10 mr-b3">시작시간</div>
      <el-row>
        <el-select v-model="dSchedule.startTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="dSchedule.startMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr>
      <div class="mr-t10 mr-b3">종료시간</div>
      <el-row>
        <el-select v-model="dSchedule.endTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="dSchedule.endMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr>
      <div class="mr-t10 mr-b3">스케줄 종료일</div>
      <el-row>
        <el-date-picker v-model="dSchedule.endScheduleDate" type="date" format="yyyy-MM-dd" :clearable="false" />
      </el-row>
    </div>
    <div v-show="scheduleType === 'W'">
      <div class="mr-t10 mr-b3">시작요일</div>
      <el-row>
        <el-radio-group v-model="wSchedule.startDay">
          <el-radio-button v-for="day in WEEK" :key="day.week" :label="day.week">{{day.label}}</el-radio-button>
        </el-radio-group>
      </el-row>
      <div class="mr-t10 mr-b3">시작시간</div>
      <el-row>
        <el-select v-model="wSchedule.startTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="wSchedule.startMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr class="mr-t10">
      <div class="mr-t10 mr-b3">종료요일</div>
      <el-row>
        <el-radio-group v-model="wSchedule.endDay">
          <el-radio-button v-for="day in WEEK" :key="day.week" :label="day.week">{{day.label}}</el-radio-button>
        </el-radio-group>
      </el-row>
      <div class="mr-t10 mr-b3">종료시간</div>
      <el-row>
        <el-select v-model="wSchedule.endTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="wSchedule.endMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr class="mr-t10">
      <div class="mr-t10 mr-b3">스케줄 종료일</div>
      <el-row>
        <el-date-picker v-model="wSchedule.endScheduleDate" type="date" format="yyyy-MM-dd" :clearable="false" />
      </el-row>
    </div>
    <div v-show="scheduleType === 'M'">
      <div class="mr-t10 mr-b3">시작날짜</div>
      <el-row>
        <el-select v-model="mSchedule.startDate" placeholder="Select">
          <el-option v-for="i in monthendScheduleDate" :key="i" :label="i" :value="i" />
          <el-option label="마지막 날" :value="0" />
        </el-select>
        <span>일</span>
      </el-row>
      <div class="mr-t10 mr-b3">시작시간</div>
      <el-row>
        <el-select v-model="mSchedule.startTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="mSchedule.startMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr class="mr-t10">
      <div class="mr-t10 mr-b3">종료날짜</div>
      <el-row>
        <el-select v-model="mSchedule.endDate" placeholder="Select">
          <el-option v-for="i in monthendScheduleDate" :key="i" :label="i" :value="i" />
          <el-option label="마지막 날" :value="0" />
        </el-select>
        <span>일</span>
      </el-row>
      <div class="mr-t10 mr-b3">종료시간</div>
      <el-row>
        <el-select v-model="mSchedule.endTime" placeholder="Select">
          <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
        </el-select>
        <span>시</span>
        <el-select v-model="mSchedule.endMinute" placeholder="Select">
          <el-option v-for="item in MINUTE" :key="item.minute" :label="item.label" :value="item.minute" />
        </el-select>
        <span>분</span>
      </el-row>
      <hr class="mr-t10">
      <div class="mr-t10 mr-b3">스케줄 종료일</div>
      <el-row>
        <el-date-picker v-model="mSchedule.endScheduleDate" type="date" format="yyyy-MM-dd" :clearable="false" />
      </el-row>
    </div>
    <!-- end 1217 -->
  </div>
</template>

<script>
import moment from 'moment';
import keys from 'lodash/keys';
import { TIME, MINUTE, WEEK } from '@/constants/date';

export default {
  name: 'WWorkTimeView',
  props: {
    selectedDate: {
      type: Date,
    },
  },
  data() {
    return {
      TIME,
      MINUTE,
      WEEK,
      scheduleType: 'O',
      scheduleTypeObj: {
        O: { scheduleType: 'O', label: '한번' },
        D: { scheduleType: 'D', label: '매일' },
        W: { scheduleType: 'W', label: '매주' },
        M: { scheduleType: 'M', label: '매달' },
      },
      oSchedule: {
        startTime: 0,
        startMinute: 0,
        endTime: 23,
        endMinute: 59,
      },
      dSchedule: {
        startTime: 0,
        startMinute: 0,
        endTime: 23,
        endMinute: 59,
        endScheduleDate: moment().format('YYYY-MM-DD'),
      },
      wSchedule: {
        startTime: 0,
        startMinute: 0,
        startDay: 0,
        endTime: 23,
        endMinute: 59,
        endDay: 0,
        endScheduleDate: moment().format('YYYY-MM-DD'),
      },
      mSchedule: {
        startTime: 0,
        startMinute: 0,
        startDate: 1,
        endTime: 23,
        endMinute: 59,
        endDate: 1,
        endScheduleDate: moment().format('YYYY-MM-DD'),
      },
      monthendScheduleDate: null, // 선택된 달의 마지막 날짜
      currentDate: null,
    };
  },
  mounted() {
    this.initWorkTime();
  },
  methods: {
    keys,
    getWorkTime() {
      const scheduleType = this.scheduleType;
      const workTime = {
        scheduleType,
        selectedDate: this.selectedDate,
      };

      let scheduleData = {};
      const startDatetime = moment(workTime.selectedDate);
      const endDatetime = moment(workTime.selectedDate);

      /*
        [한번(O)/매일(D)]
        - 선택된 날짜(시간)에 대한 시작시간~종료시간
        [매주(W)/매월(M)]
        - 선택된 날짜(시간)에 대해 '시작시간 < 현재 시간 < 종료시간' 일 경우 해당 시간 포함
        - 그 외의 경우 다음 주기 설정
       */
      scheduleData = this[`${scheduleType.toLowerCase()}Schedule`];
      const endScheduleDate = moment(scheduleData.endScheduleDate).endOf('day').toDate();

      // 종료일이 선택된 날짜보다 작을 경우 (한번일 경우 종료일 없음)
      if (scheduleType !== 'O' && workTime.selectedDate.getTime() > endScheduleDate.getTime()) {
        return false;
      }

      // 설정된 시작시간/종료시간 설정
      startDatetime.hours(scheduleData.startTime).minutes(scheduleData.startMinute).seconds(0);
      endDatetime.hours(scheduleData.endTime).minutes(scheduleData.endMinute).seconds(0);

      if (scheduleType === 'O' || scheduleType === 'D') {
        if (endDatetime.diff(startDatetime) <= 0) {
          // 한번, 일간 선택시 23:00 ~ 01:00 등 날짜가 변경되는 시간대에 설정할수 있도록 수정
          // return false;
          endDatetime.add(1, 'days');
        }
      } else if (scheduleType === 'W') {
        startDatetime.weekday(scheduleData.startDay);
        endDatetime.weekday(scheduleData.endDay);

        // 1. 시작시간(요일포함)과 종료시간(요일포함)이 같을 경우 저장 불가
        // 2. 종료요일이 시작요일보다 작을 경우 (금요일~월요일) 종료요일은 해당 주의 다음주로 설정
        if (endDatetime.toDate().getTime() === startDatetime.toDate().getTime()) {
          return false;
        } else if (endDatetime.toDate().getTime() < startDatetime.toDate().getTime()) {
          endDatetime.weekday(7);
        }
      } else if (scheduleType === 'M') {
        const startDate = scheduleData.startDate === 0 ? moment(workTime.selectedDate).endOf('month').dates() : scheduleData.startDate;
        const endDate = scheduleData.endDate === 0 ? moment(workTime.selectedDate).endOf('month').dates() : scheduleData.endDate;

        startDatetime.dates(startDate);
        endDatetime.dates(endDate);

        // 1. 시작시간(날짜포함)과 종료시간(날짜포함)이 같을 경우 저장 불가
        // 2. 종료날짜가 시작날짜보다 작을 경우 (20일~10일) 종료날짜는 해당 달의 다음달로 설정
        if (endDatetime.toDate().getTime() === startDatetime.toDate().getTime()) {
          return false;
        } else if (endDatetime.toDate().getTime() < startDatetime.toDate().getTime()) {
          endDatetime.add(1, 'months');
        }
      }

      scheduleData.startDatetime = startDatetime.toDate();
      scheduleData.endDatetime = endDatetime.toDate();
      scheduleData.endScheduleDate = endScheduleDate;
      workTime.scheduleDetail = this.getScheduleDetail(scheduleData);
      workTime.scheduleData = scheduleData;
      return workTime;
    },
    initWorkTime() {
      this.scheduleType = 'O';
      this.monthendScheduleDate = moment(this.selectedDate).endOf('month').dates();
      this.currentDate = moment(this.selectedDate).dates();

      const initTime = { startTime: 0, startMinute: 0, endTime: 23, endMinute: 59 };
      this.oSchedule = initTime;
      this.dSchedule = { ...initTime, endScheduleDate: moment().format('YYYY-MM-DD') };
      this.wSchedule = { ...initTime, startDay: 0, endDay: 0, endScheduleDate: moment().format('YYYY-MM-DD') };
      this.mSchedule = { ...initTime, startDate: this.currentDate, endDate: this.currentDate, endScheduleDate: moment().format('YYYY-MM-DD') };
    },
    /**
     * scheduleDetail 설정
     * @author kimjy
     * @param  {Object} scheduleData
     * @return {String}              scheduleDetail
     */
    getScheduleDetail(scheduleData) {
      const scheduleType = this.scheduleType;
      const scheduleTypeName = this.scheduleTypeObj[this.scheduleType].label;
      /*
        [한번] 00시 00분 ~ 00시 00분
        [정기작업/매일] 00시 00분 ~ 00시 00분
        [정기작업/매주] 수요일 00시 00분 ~ 금요일 00시 00분
        [정기작업/매월] 1일 00시 00분 ~ 마지막날 00시 00분
       */
      let scheduleDetail = `[${scheduleType !== 'O' ? '정기점검/' : ''}${scheduleTypeName}] `;
      let startDetail = `${TIME[scheduleData.startTime].label}시 ${MINUTE[scheduleData.startMinute].label}분`;
      let endDetail = `${TIME[scheduleData.endTime].label}시 ${MINUTE[scheduleData.endMinute].label}분`;
      if (scheduleType === 'W') {
        startDetail = `${WEEK[scheduleData.startDay].label} ${startDetail}`;
        endDetail = `${WEEK[scheduleData.endDay].label} ${endDetail}`;
      } else if (scheduleType === 'M') {
        const startDate = scheduleData.startDate === 0 ? '마지막날' : `${scheduleData.startDate}일`;
        const endDate = scheduleData.endDate === 0 ? '마지막날' : `${scheduleData.endDate}일`;
        startDetail = `${startDate} ${startDetail}`;
        endDetail = `${endDate} ${endDetail}`;
      }
      scheduleDetail = `${scheduleDetail}${startDetail} ~ ${endDetail}`;
      return scheduleDetail;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/popup/components/WorkTimeView.vue